// @flow
import axios from 'lib/defaultClient';

export const getTempSaveList = (partnerId: string) => axios.get(`/partners/${partnerId}/saves`);

export type LoadTempSavePayload = {
  partnerId: string,
  saveId: string,
};

export const loadTempSave = ({ partnerId, saveId }: LoadTempSavePayload) => {
  return axios.get(`/partners/${partnerId}/saves/${saveId}`);
};



// WEBPACK FOOTER //
// ./src/lib/api/partners/saves.js